<script>
import MainLayout from '../layouts/mainLayout'
import {RoleFlagCheck} from '@/utils/RoleFlagCheck.js'
import {ExceptionCommonUtil} from '@/utils/Exception'
import {formatDate, DateUtil} from '@/utils/date.js'
import driver from '@/components/driver'
// 出力
import dialog from '@/components/Dialog'
export default {
  components: {MainLayout, driver, 'v-dialog': dialog},
  data () {
    return {
      // 判断系统当前用户权限
      isMasterManager: false,
      // 是否出力，默认为false
      isPrint: false,
      checkList: [],
      // 表标题栏 是否全选出力
      isSelectAll: false,
      // 出力Dialog
      showPrintDialog: false,
      dialogPrintOption: {
        showNo: true,
        text: 'データをダウンロードします。<br/>よろしいですか？',
        cancelButtonText: 'キャンセル',
        confirmButtonText: '実行'
      },
      title: 'ドライバーリスト',
      // driver详细弹窗标题
      driverDetailTitle: 'ドライバー詳細',
      sortRadio: 'asc',
      infoList: [],
      infoListStore: [],
      // 搜索框的值
      inputdata: '',
      isMember: 'false',
      // 传给弹框的值:司机详细,点击按钮，获取Item赋给它，然后利用Props传到子弹出框
      userInfoDetail: {},
      // 会員checkbox
      userCheckbox: false,
      // ドライバーcheckbox
      driverCheckbox: false,
      // 管理者checkbox
      adminCheckbox: false,
      // 活動年数
      activityYear: '１ヶ月',
      // 登録日 默认：系统当前日期 格式：yyyy年MM月dd日
      inTime: '',
      // ドライバー登録日 默认：系统当前日期 格式：yyyy年MM月dd日
      driverInTime: '',
      // user年龄
      age: 0,
      // 三张图片URL
      option: {
        img1: null,
        file1: null,
        img2: null,
        file2: null,
        img3: null,
        file3: null
      },
      // 生日
      birthday: '',

      // 将userInfoDetail分为普通用户和Driver两个子集
      // ユーザープロフィール情報
      userProfileModel: {
        lastName: '',
        firstName: '',
        lastNameKana: '',
        firstNameKana: '',
        sex: 0,
        birthday: '',
        homeAddress: '',
        homeLat: '',
        homeLng: '',
        homeTelephone: '',
        portableTelephone: '',
        postalcode: '',
        fax: '',
        passengerCost: null,
        loginId: '',
        password: '',
        note: ''
      },
      // ドライバープロフィール情報
      userDriverProfileModel: {
        facePhotoUrl: '',
        driverLicenseDeadline: '',
        joinDate: '',
        accidentFlag: 0,
        accidentDetails: '',
        sanctionFlag: 0,
        sanctionDetails: '',
        rewardFlag: 0,
        driverLicensePhotoUrl1: '',
        driverLicensePhotoUrl2: ''
      },
      // 交通事業者名
      transportName: '',
      // 交通事業者チェックボックス（フラグ）
      transportCheckbox: false,
    }
  },

  watch: {
    // 切换排序时重新显示数据  kana排序
    sortRadio (newvalue) {
      if (newvalue === 'asc') {
        this.infoList.sort((x, y) => {
          return (x.lastNameKana + x.firstNameKana).localeCompare(y.lastNameKana + y.firstNameKana)
        })
      } else {
        this.infoList.sort((x, y) => {
          return -(x.lastNameKana + x.firstNameKana).localeCompare(y.lastNameKana + y.firstNameKana)
        })
      }
      // driverSelectItem用来存储检索条件，便于再次返回时的一览界面
      sessionStorage.setItem('driverSelectItem', JSON.stringify({'inputdata': this.inputdata, 'sortRadio': this.sortRadio}))
    }
  },
  // 出力CheckList
  created: function () {
    console.log(this.isSelectAll)
    // 获取当前用户的权限
    let loginRoleFlag = sessionStorage.getItem('currentUserRoleFlag')
    this.isMasterManager = RoleFlagCheck.masterManager(loginRoleFlag)
    this.$axios.get('driver/queryDriverInfoList')
      .then((response) => {
        this.infoListStore = response.data.driverInfoList
        this.infoList = response.data.driverInfoList
        sessionStorage.setItem('infoList', JSON.stringify(this.infoList))
        if (JSON.parse(sessionStorage.getItem('driverSelectItem') !== null)) {
          // alert('a')
          let driverSelectItemInfo = JSON.parse(sessionStorage.getItem('driverSelectItem'))
          this.inputdata = driverSelectItemInfo.inputdata
          this.infoList = this.infoListStore.filter(item => (item.lastName + item.firstName).includes(this.inputdata.trim().replace(' ', '')))
        }
        this.infoList.sort((x, y) => {
          return (x.lastNameKana + x.firstNameKana).localeCompare(y.lastNameKana + y.firstNameKana)
        })
      })
      .catch((error) => {
        alert(error.response.data.error_description)
        ExceptionCommonUtil.exceptionHandle(error)
      })
    // 出力CheckList
    this.setCheckList()
    // for (let i = 0; i < this.infoList.length; i++) {
    //   this.checkList.push(false)
    // }
  },
  methods: {
    setCheckList () {
      // this.isSelectAll = false
      // 出力CheckList
      for (let i = 0; i < this.infoList.length; i++) {
        this.checkList.push(false)
      }
    },
    // 查询框失去焦点或者enter键后请求数据
    selectData () {
      this.infoList = this.infoListStore.filter(item => (item.lastName + item.firstName).includes(this.inputdata.trim().replace(' ', '')))
      // accountSelectItem用来存储检索条件，便于再次返回时的一览界面
      sessionStorage.setItem('driverSelectItem', JSON.stringify({'inputdata': this.inputdata, 'currentId': this.currentId, 'sortRadio': this.sortRadio}))
    },
    // 单个司机个人所有计划表
    oneDriverScheduleDetail (uid, lastName, firstName) {
      sessionStorage.setItem('userId', uid)
      let driverName = lastName + ' ' + firstName
      sessionStorage.setItem('driverName', driverName)
      this.$router.push({ name: 'OneDriverSchedule' })
    },
    // check权限角色
    memberCheck (roleFlag) {
      return RoleFlagCheck.member(roleFlag)
    },
    driverCheck (roleFlag) {
      return RoleFlagCheck.diver(roleFlag)
    },
    generalManagerCheck (roleFlag) {
      return RoleFlagCheck.generalManager(roleFlag)
    },
    masterManagerCheck (roleFlag) {
      return RoleFlagCheck.masterManager(roleFlag)
    },
    transportCheck (roleFlag) {
      return RoleFlagCheck.transport(roleFlag)
    },
    
    // 免证允许有效期限格式化
    convertDate (date) {
      return DateUtil.yearMonthandDay(date)
    },
    // 全员日程表一览
    showScheduleList () {
      this.$router.push('DriverScheduleList')
    },

    // driver详细弹窗
    driverDetail (item) {
      this.userInfoDetail = item
      this.userProfileModel.lastName = this.userInfoDetail.lastName
      this.userProfileModel.firstName = this.userInfoDetail.firstName
      this.userProfileModel.lastNameKana = this.userInfoDetail.lastNameKana
      this.userProfileModel.firstNameKana = this.userInfoDetail.firstNameKana
      this.userProfileModel.sex = this.userInfoDetail.sex
      this.userProfileModel.birthday = this.userInfoDetail.birthday
      this.userProfileModel.homeAddress = this.userInfoDetail.homeAddress
      this.userProfileModel.homeLat = this.userInfoDetail.homeLat
      this.userProfileModel.homeLng = this.userInfoDetail.homeLng
      this.userProfileModel.homeTelephone = this.userInfoDetail.homeTelephone
      this.userProfileModel.portableTelephone = this.userInfoDetail.portableTelephone
      this.userProfileModel.postalcode = this.userInfoDetail.postalCode
      this.userProfileModel.fax = this.userInfoDetail.fax
      this.userProfileModel.passengerCost = this.userInfoDetail.passengerCost
      this.userProfileModel.loginId = this.userInfoDetail.loginId
      this.userProfileModel.password = this.userInfoDetail.password
      this.userProfileModel.note = this.userInfoDetail.note
      // console.log(this.userProfileModel)
      // 用户写真
      this.userDriverProfileModel.facePhotoUrl = this.userInfoDetail.facePhotoUrl
      this.userDriverProfileModel.driverLicenseDeadline = this.userInfoDetail.driverLicenseDeadline
      if (this.userInfoDetail.joinDate == null) {
        this.userDriverProfileModel.joinDate = formatDate(new Date(), 'yyyy年MM月dd日')
      } else {
        this.userDriverProfileModel.joinDate = this.userInfoDetail.driverJoinDate
      }
      this.userDriverProfileModel.accidentFlag = this.userInfoDetail.accidentFlag
      this.userDriverProfileModel.accidentDetails = this.userInfoDetail.accidentDetails
      this.userDriverProfileModel.sanctionFlag = this.userInfoDetail.sanctionFlag
      this.userDriverProfileModel.sanctionDetails = this.userInfoDetail.sanctionDetails
      this.userDriverProfileModel.rewardFlag = this.userInfoDetail.rewardFlag
      // 司机期限写真1
      this.userDriverProfileModel.driverLicensePhotoUrl1 = this.userInfoDetail.driverLicensePhotoUrl1
      // 司机期限写真2
      this.userDriverProfileModel.driverLicensePhotoUrl2 = this.userInfoDetail.driverLicensePhotoUrl2
      // console.log(this.userDriverProfileModel)

      this.inTime = DateUtil.yearMonthDay(this.userInfoDetail.joinDate) // 登陆日
      if (this.userInfoDetail.driverJoinDate === null || this.userInfoDetail.driverJoinDate === '') {
        this.driverInTime = DateUtil.dateToString(new Date())
      } else {
        this.driverInTime = DateUtil.yearMonthDay(this.userInfoDetail.driverJoinDate)
      }
      this.birthday = DateUtil.yearMonthDay(this.userInfoDetail.birthday) // 生日
      this.age = DateUtil.yearCompute(this.userInfoDetail.birthday) // 年龄
      if (this.userInfoDetail.driverJoinDate === null || this.userInfoDetail.driverJoinDate === '') {
        this.activityYear = '１ヶ月'
      } else {
        this.activityYear = DateUtil.yearMonthCompute(this.userInfoDetail.driverJoinDate)
      }
      // console.log(this.option)
      // 图片
      this.option.img1 = this.userDriverProfileModel.facePhotoUrl
      this.option.img2 = this.userDriverProfileModel.driverLicensePhotoUrl1
      this.option.img3 = this.userDriverProfileModel.driverLicensePhotoUrl2
      // console.log(this.option)
      // 三种权限：会员、司机、管理者
      this.userCheckbox = RoleFlagCheck.member(this.userInfoDetail.roleFlag)
      this.driverCheckbox = RoleFlagCheck.diver(this.userInfoDetail.roleFlag)
      if (RoleFlagCheck.generalManager(this.userInfoDetail.roleFlag) || RoleFlagCheck.masterManager(this.userInfoDetail.roleFlag)) {
        this.adminCheckbox = true
      } else this.adminCheckbox = false
      // 交通事業者名
      this.transportName = this.userInfoDetail.transportName
      
      if((this.userInfoDetail.transportId) != null){
        this.transportCheckbox = true
      }else{
        this.transportCheckbox = false
      }
    },
    // 一览出力
    driverListPrint () {
      this.title = '[出力]ドライバー'
      this.isPrint = true
    },
    // 出力
    print () {
      let falseCheckList = this.checkList.filter(item => item === false)
      if (falseCheckList.length === this.checkList.length) {
        this.dialogPrintOption.text = 'ドライバーを選択してください。'
        this.dialogPrintOption.showNo = false
        this.dialogPrintOption.confirmButtonText = 'OK'
      } else {
        this.dialogPrintOption.text = 'データをダウンロードします。<br/>よろしいですか？'
        this.dialogPrintOption.showNo = true
        this.dialogPrintOption.cancelButtonText = 'キャンセル'
        this.dialogPrintOption.confirmButtonText = '実行'
      }
      this.showPrintDialog = true
      this.$refs.printDialog.confirm().then(() => {
        if (falseCheckList.length !== this.checkList.length) {
          let printList = []
          for (let i = 0; i < this.infoList.length; i++) {
            if (this.checkList[i]) {
              printList.push(this.infoList[i])
            }
          }
          console.log(printList)
          this.$axios.post('driver/exportDriverCsv', printList, {responseType: 'arraybuffer'}).then((res) => {
            let fileName = 'ドライバーリスト.csv'
            let blob = new Blob([res.data], { type: 'application/x-xls' })
            if (window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName)
            } else {
              var link = document.createElement('a')
              link.href = window.URL.createObjectURL(blob)
              link.download = fileName
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }).catch(error => {
            console.log(error)
            let dialogPrintOption = {
              showNo: false,
              text: '予期せぬエラーが発生しました。',
              confirmButtonText: 'OK'
            }
            this.dialogPrintOption = dialogPrintOption
            this.showPrintDialog = true
            this.$refs.printDialog.confirm().then(() => {
              this.showPrintDialog = false
            })
          })
        }
        this.showPrintDialog = false
      }).catch(() => {
        this.showPrintDialog = false
      })
    },
    // 取消出力
    cancelPrint () {
      this.title = 'ドライバー'
      this.isPrint = false
      // 清空单选框
      this.isSelectAll = true
      this.checkedAll()
    },
    // 出力全选框
    checkedAll () {
      this.isSelectAll = !this.isSelectAll
      let checkList = []
      if (this.isSelectAll) {
        for (let i = 0; i < this.infoList.length; i++) {
          checkList.push(true)
          this.checkList = checkList
        }
      } else {
        for (let i = 0; i < this.infoList.length; i++) {
          checkList.push(false)
          this.checkList = checkList
        }
      }
    },
    goToDriverCard (item) {
      this.$router.push({name: 'DriverCard', query: {uid: item.uid}})
    },
  },
  // 路由离开前的操作，清楚掉session
  beforeRouteLeave (to, from, next) {
    const arr = ['/MovementStatus', '/MovementShift', '/RouteList', '/StationList', '/VehicleList', '/MemberList']
    arr.forEach(i => {
      if (to.path === i) {
        if (sessionStorage.getItem('driverSelectItem')) {
          sessionStorage.removeItem('driverSelectItem')
        }
      }
    })
    next()
  }
}
</script>

<template>
  <main-layout>
    <div class="col-md-12 column" style="display:flex;flex-direction: column;flex:1;margin-bottom: 30px;margin-top:18px;">
      <div class="row clearfix" style="flex:0 0 60px;position: relative;display:flex;flex-direction: row-reverse;">
        <div class="col-md-8 column F3-M-27" style="position: absolute;width: 100%;">
          {{title}}
        </div>
        <div class="col-md-4 column headerbtndiv" style="width:360px;">
          <!-- <button class="common-btn user-btn F2-M-19 detailed-button" style="border:0px"> 報酬管理出力</button> -->
          <button class="common-btn user-btn F2-M-19 detailed-button" style="border:0px" @click="showScheduleList()"> スケジュール</button>
          <button class="common-btn user-btn F2-M-19 detailed-button" style="border:0px" @click="driverListPrint()">一覧出力</button>
        </div>
      </div>
      <div class="row clearfix conditiondiv" style="flex:0 0 45px;">
        <div class="col-md-9 inputdiv">
          <input type="text" title="検索" placeholder="検索" v-model="inputdata" @blur="selectData" @keydown.enter="selectData" />
        </div>
        <div class=" col-md-2 radiodiv">
          <label class="radio-inline" style="float: left;">
            <input class="radiobtn" type="radio" name="memberIdRadio" v-model="sortRadio" id="ascRadio" value="asc">
            <span></span>
            <span class="F3-R-22"> 昇順</span>
          </label>
          <label class="radio-inline" style="float: left;">
            <input class="radiobtn" type="radio" name="memberIdRadio" v-model="sortRadio" id="dscRadio" value="dsc">
            <span></span>
            <span class="F3-R-22"> 降順</span>
          </label>
        </div>
      </div>
      <!-- 传参数传  item    220px  330px 160px-->
      <div class="table-container" style="flex: 1;">
        <div class=" table-header" style="padding-right:10px; flex:0 0 30px">
          <table>
            <thead>
              <tr class="theader bgc9 F2-R-15">
                <td v-show="isPrint" class="trborder1 bodytext td-print" style="width:3%">
                  <div style="display: flex;justify-content: center;align-items: center;padding-left:10px;height:100%">
                    <input type="checkbox" v-model="isSelectAll" style="height:20px;width:20px;margin-left:-14px;" @click='checkedAll()'>
                  </div>
                </td>
                <td class="trborder td-name">氏名</td>
                <td class="trborder td-kana">カナ</td>
                <td class="trborder td-accountId">アカウントID</td>
                <td class="trborder td-tel">電話番号</td>
                <td class="trborder td-tel">携帯番号</td>
                <td class="trborder td-allow" v-show="!isPrint">運転免許有効期限</td>
                <td class="td-role"></td>
                <td class="td-button"></td>
                <td class="td-button1"></td>
              </tr>
            </thead>
          </table>
        </div>
        <div class="table-body scrollbar">
          <table class="table">
            <tbody>
              <tr class="contenttr bgc5h" v-for='(item, index) in infoList' :key="item.uid">
                <td v-show="isPrint" class="trborder1 bodytext td-print" style="width:3%">
                  <div style="display: flex;justify-content: center;align-items: center;padding-left:10px;height:100%">
                    <input type="checkbox" v-model="checkList[index]" style="height:20px;width:20px;margin-left:-10px;">
                  </div>
                </td>
                <td class="trborder1 bodytext td-name F3-R-19 member-name" :title="item.lastName+item.firstName" @click="driverDetail(item)" data-toggle="modal" href="#modal-container-475051">{{item.lastName}} {{item.firstName}}</td>
                <td class="trborder1 bodytext td-kana F3-R-19 member-name" :title="item.lastNameKana+item.firstNameKana" @click="driverDetail(item)" data-toggle="modal" href="#modal-container-475051">{{item.lastNameKana}} {{item.firstNameKana}}</td>
                <td class="trborder1 bodytext td-accountId F3-R-19" @click="driverDetail(item)" data-toggle="modal" href="#modal-container-475051">{{item.loginId}}</td>
                <td class="trborder1 bodytext td-tel F3-R-19" @click="driverDetail(item)" data-toggle="modal" href="#modal-container-475051">{{item.homeTelephone}}</td>
                <td class="trborder1 bodytext td-tel F3-R-19" @click="driverDetail(item)" data-toggle="modal" href="#modal-container-475051">{{item.portableTelephone}}</td>
                <td v-show="!isPrint" class="trborder1 bodytext td-allow F3-R-19" @click="driverDetail(item)" data-toggle="modal" href="#modal-container-475051">{{convertDate(item.driverLicenseDeadline)}}</td>
                <td class="td-role" @click="driverDetail(item)" data-toggle="modal" href="#modal-container-475051">
                  <div class="role-div">
                    <div class="role-img">
                      <img src="../../assets/icon/member_status1.png" class="role-img" v-show="memberCheck(item.roleFlag)">
                    </div>
                    <div class="role-img">
                      <img src="../../assets/icon/member_status2.png" class="role-img" v-show="driverCheck(item.roleFlag)">
                      <img src="../../assets/icon/member_status5.png" class="role-img" v-show="transportCheck(item.roleFlag)">
                    </div>
                    <div class="role-img">
                      <img src="../../assets/icon/member_status3.png" class="role-img" v-show="generalManagerCheck(item.roleFlag)">
                      <img src="../../assets/icon/member_status4.png" class="role-img" v-show="masterManagerCheck(item.roleFlag)">
                    </div>
                  </div>
                </td>
                <td class="td-button">
                  <div class="orderbtn-div" v-show="!isPrint">
                    <button class="orderbtn F2-M-16 detailed-button" @click="goToDriverCard(item)" v-show="!transportCheck(item.roleFlag)">運転者証</button>
                  </div>
                </td>
                <td class="td-button1">
                  <div class="orderbtn-div" v-show="!isPrint">
                    <button class="orderbtn1 F2-M-16 detailed-button" @click="oneDriverScheduleDetail(item.uid, item.lastName, item.firstName)">スケジュール</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <driver :title="driverDetailTitle" :userProfileModel="userProfileModel" :userDriverProfileModel="userDriverProfileModel"
          :option="option" :birthday="birthday" :adminCheckbox="adminCheckbox" :userCheckbox="userCheckbox" :inTime="inTime"
          :driverInTime="driverInTime" :age="age" :activityYear="activityYear" :driverCheckbox="driverCheckbox" :isMasterManager="isMasterManager" 
          :transportName="transportName" :transportCheckbox="transportCheckbox" ref="userInfoDialog"></driver>
      </div>
      <!-- footer 出力时显示两个按钮 -->
      <div class="row clearfix footer" v-show="isPrint" style="margin-top:20px">
        <div class="col-md-6 column">
          <button class="driver-button" style="float:right" @click="print">出力</button>
        </div>
        <div class="col-md-6 column">
          <button class="driver-button" style="float:left" @click="cancelPrint">キャンセル</button>
        </div>
      </div>
      <v-dialog v-show="showPrintDialog" :dialog-option="dialogPrintOption" ref="printDialog"></v-dialog>
    </div>
  </main-layout>
</template>

<style lang="scss" scoped> // @import "../../assets/css/C00.css";
.name-strong {
  font-size: 30px;
}

.headerbtndiv {
  display: flex;
  flex-direction: row; // float: right; // width: 420px;想要按钮固定式可以设置该div的宽度
}

.user-btn {
  // float: right;
  margin-right: 5px;
  flex: 1;
  width: auto !important;
}

.conditiondiv {
  display: flex;
  flex-direction: row;
  flex: 0 0 45px;
}

.inputdiv {
  border: solid 2px #ccc;
  border-radius: 10px;
  width: 70%; //flex: 3;
  height: 45px;
  background: url(../../assets/select.png) no-repeat 10px center;
  margin-left: 180px; //150px
}

//width: 100%;
.inputdiv input {
  border: none;
  outline: none;
  background: none;
  width: 100%; //550px
  height: 45px;
  /* 可以对应调整.text中的backgroud和下面的text-indent调整图标和input输入地方的间距 */
  text-indent: 40px;
}

.radiodiv {
  border-radius: 10px;
  width: 390px; //390px 25%
  height: 30px; //flex: 2;
  margin-left: 10px;
  margin-top: 6px;
  font-size: 20px;
}

.radiobtn {
  margin-top: 0px;
  height: 30px;
  width: 30px;
}

input[type="radio"]+span {
  display: inline-block;
  width: 10px;
  vertical-align: middle;
}

.trborder {
  border-right: 1px solid rgb(190, 190, 190);
  // border-right:1px solid red;
}

.trborder1 {
  border-right: 1px solid rgb(255, 255, 255);
}

//设置各个字段td的宽度百分比
.td-name {
  width: 13%
}

.td-kana {
  width: 20%;
}

.td-accountId {
  width: 10%;
}

.td-tel {
  width: 11%;
}

.td-allow {
  width: 10%;
}

.td-role {
  width: 8%;
}

.td-button {
  width: 7%;
}

.td-button1 {
  width: 10%;
}

.role-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 3px;
  margin-right: 3px;
  .role-img {
    width: 25px;
    height: 25px;
  }
}

.td-role {
  width: 115px;
}

.orderbtn-div {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.orderbtn {
  height: 30px;
  width: 100px; //更改100
  border: none;
  border-radius: 4px;
  background-color: rgb(138, 138, 138)
}

.orderbtn1 {
  height: 30px;
  width: 150px; //更改150
  border: none;
  border-radius: 4px;
  background-color: rgb(138, 138, 138)
}

.driver-button {
  // border: 1px solid red;
  width: 60%;
  height: 50px;
  border-radius: 10px;
  background: linear-gradient(#70b6ca 50%, #48a3be 50%) !important;
  border: 0px;
  /* margin: 30px; */
  font-size: 22px;
  color: #fff;
  background-color: #717171;
}

.member-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.myScrollbar {
  overflow: scroll;
  height: 100%;
  min-height: 0;
  min-width: 0;
}

</style>



// WEBPACK FOOTER //
// src/router/views/DriverList.vue